import styled from 'styled-components';
import Checkbox from 'antd/es/checkbox';

import { GetSCProps } from '@utils/types';

type Props = GetSCProps<'color'>;

export const StyledCheckBox = styled(Checkbox)<Props>`
  &&& {
    display: flex;

    & span ~ span {
      display: flex;
      align-items: center;
    }
    &.setur-checkbox-wrapper:hover .setur-checkbox-inner,
    .setur-checkbox:hover .setur-checkbox-inner,
    .setur-checkbox-input:focus + .setur-checkbox-inner {
      border-color: ${(p) => p.theme.palette?.tomato ?? p.color};
    }
    .setur-checkbox-checked .setur-checkbox-inner {
      background-color: ${(p) => p.theme.palette?.tomato ?? p.color};
      border-color: ${(p) => p.theme.palette?.tomato ?? p.color};
    }
    .setur-checkbox-checked::after {
      border-color: ${(p) => p.theme.palette?.tomato ?? p.color};
    }
  }
`;

export const CheckBoxSubTitle = styled.span`
  opacity: 0.6;
  font-size: 13px;
`;
